module.exports = __webpack_public_path__ + "img/TW.39168969.png";